import clz from 'classnames';
import { FunctionComponent } from 'react';
import { Portal } from 'react-portal';

import styles from './Alert.module.sass';

export enum CommonAlertMessages {
    NetworkError = 'Network error',
}

export interface AlertProps {
    text?: string;
    show: boolean;
}

const Alert: FunctionComponent<AlertProps> = ({ text, show, children }) => {
    return (
        <Portal>
            <div className={clz(styles.container, { [styles.hide]: !show })}>
                {text || children}
            </div>
        </Portal>
    );
};

export default Alert;
